


























import { Component, Vue, Prop, Watch } from 'nuxt-property-decorator'

interface Model {
  name: string;
  company: string;
  email: string;
  phone: string;
  agreement: boolean;
}

const emailPattern = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
const phonePattern = /^[\s()+-]*([0-9][\s()+-]*){6,20}$/

@Component<MBriefContact>({})
export default class MBriefContact extends Vue {
  @Prop({ default: undefined }) value!: Model

  terms: {
    required: boolean;
    text: string;
    link?: {
      to: string;
      label: string;
    }
  } = {
    required: true,
    text: 'pages.brief.form.terms.text',
    link: {
      to: this.localePath({ name: 'privacy-policy' }),
      label: 'pages.brief.form.terms.link'
    }
  }

  model: Model = {
    name: '',
    company: '',
    email: '',
    phone: '',
    agreement: false
  }

  errors: {
    fields: string[];
    message: string;
  }[] = []

  mounted() {
    if (this.value) {
      this.model = this.value
    }
  }

  getErrors(field: string) {
    return this.errors.filter(e => e.fields.find(f => f === field))
  }
  
  @Watch('model', { deep: true, immediate: true })
  onModelChange(newModel: Model) {
    this.errors = []

    if (!this.model.name && !this.model.company) {
      this.errors.push({
        fields: ['name', 'company'],
        message: 'Musisz podać imię i nazwisko lub nazwę firmy'
      })
    }

    if (!this.model.email && !this.model.phone) {
      this.errors.push({
        fields: ['email', 'phone'],
        message: 'Musisz podać email lub numer telefonu'
      })
    } else {
      if (this.model.email) {
        if (!emailPattern.test(this.model.email)) {
          this.errors.push({
            fields: ['email'],
            message: 'Adres email jest niepoprawny'
          })
        }
      }

      if (this.model.phone) {
        if (!phonePattern.test(this.model.phone)) {
          this.errors.push({
            fields: ['phone'],
            message: 'Podany numer telefonu jest niepoprawny'
          })
        }
      }
    }

    if (!this.model.agreement) {
      this.errors.push({
        fields: ['agreement'],
        message: 'Musisz wyrazić zgodę'
      })
    }

    if (this.errors.length) {
      this.$emit('onvalidation', false, this.errors)
    } else {
      this.$emit('onvalidation', true, [])
    }
  }

  onInput() {
    this.$emit('input', this.model)
  }
}
